// Canonical identifiers for the supported social login / SSO providers.
// These string values are the contract shared across the web frontend,
// the mobile app and the server (request payloads, the `socialLogin`
// account map keys, and the central-auth `socialSignIn` query param), so
// they must never be typed as bare string literals anywhere — always
// reference `ssoProvider`.
export const ssoProvider = {
  Google: "google",
  Apple: "apple",
  Microsoft: "microsoft",
} as const;

export type SsoProvider = (typeof ssoProvider)[keyof typeof ssoProvider];
